import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/home");
    } catch (err) {
      setError("Credenciales incorrectas");
    }
  };

  return (
    <div className="p-4 max-w-sm mx-auto mt-2">
      <h2 className="text-xl mb-4 font-bold text-center">Inicio de sesión</h2>

      <form onSubmit={handleLogin} className="space-y-3">
        {/* Campo EMAIL */}
        <input
          type="email"
          placeholder="Correo"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border p-2 rounded"
          required
        />

        {/* Campo CONTRASEÑA con ojito */}
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border p-2 rounded pr-10"
            required
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-disfagiapp-blue"
            title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </span>
        </div>

        {/* Error */}
        {error && <p className="text-red-600 text-center">{error}</p>}

        {/* Botón de envío */}
        <button
          type="submit"
          className="w-full bg-disfagiapp-blue hover:bg-disfagiapp-blue-hover text-white p-2 rounded font-bold"
        >
          Iniciar sesión
        </button>

        {/* 🔹 ENLACE: ¿Olvidó su contraseña? */}
        <p className="text-center mt-2">
          <button
            type="button"
            onClick={() => navigate("/reset-password")}
            className="text-disfagiapp-blue underline text-sm cursor-pointer"
          >
            ¿Olvidó su contraseña?
          </button>
        </p>
      </form>
    </div>
  );
}